export function registerDayOneServiceWorker() {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) return;
  const register = () => {
    navigator.serviceWorker.register("/service-worker.js", { updateViaCache: "none" }).catch((error) => {
      console.warn("[DayOne] Service worker indisponible", error);
    });
  };
  if (document.readyState === "complete") register();
  else window.addEventListener("load", register, { once: true });
}
